"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CAES = require("crypto-js/aes");
var CENC = require("crypto-js/enc-utf8");
var pasteparser_1 = require("./pasteparser");
// Deprecated parser which relies on base64-encoded data to
// pass off directly to cryptojs.
var BlobParserV1 = /** @class */ (function () {
    function BlobParserV1(data, name, key) {
        this.data = data;
        this.name = name;
        this.key = key;
    }
    // blobv1 only contained JSON data. Safe to stringify.
    // RIP anyone who tries to pass BSON. Good luck.
    BlobParserV1.prototype.decrypt = function () {
        var rawWords = CAES.decrypt(this.data, this.key);
        var jsonData = CENC.stringify(rawWords);
        return pasteparser_1.default.parse(this.name, this.key, jsonData);
    };
    // Legacy, won't be async.
    BlobParserV1.prototype.decryptAsync = function (progress, complete) {
        var rawWords = CAES.decrypt(this.data, this.key);
        var jsonData = CENC.stringify(rawWords);
        progress(100);
        complete(pasteparser_1.default.parse(this.name, this.key, jsonData));
    };
    return BlobParserV1;
}());
exports.default = BlobParserV1;
